import FirebaseAnalytics from "./FirebaseAnalytics";
import OKSpinAnalytics from "./OKSpinAnalytics";
import SelfBuildWebCount from "./SelfBuildWebCount";

const SendEventToAll = (event, data, sendSelfBuildOnce) => {
  if (!data) {
    data = {};
  }
  //matomo
  if (window._paq && window._paq.push) {
    if (typeof data == "object" && Object.keys(data).length > 0) {
      for (let key in data) {
        window._paq.push(["trackEvent", event, event, key, data[key]]);
      }
    } else {
      window._paq.push(["trackEvent", event, event]);
    }
  }
  //GA
  if (window.gtag) {
    window.gtag("event", event, data);
  }
  //Firebase
  if (FirebaseAnalytics.instance) {
    FirebaseAnalytics.instance.SendEvent(event, data);
  }
  //其他的一些统计
  if(OKSpinAnalytics.instance){
    OKSpinAnalytics.instance.SendEvent(event, data);
  }
  if (sendSelfBuildOnce) {
    SelfBuildWebCount.GetInstance().SendEventOnce(event, data);
  } else {
    SelfBuildWebCount.GetInstance().SendEvent(event, data);
  }
  //JSBridge: AF or Adjust
  if (window.JSBridge && window.JSBridge.SendEvent) {
    window.SendEvent(event, JSON.stringify(data));
  }
};

export const SendEvent = (event, data) => {
  SendEventToAll(event, data, true);
};

export const SendEventEveryTime = (event, data) => {
  SendEventToAll(event, data, false);
};

export const BindUser = (rid) => {
  console.log("BindUser", rid);
  if (window.JSBridge && window.JSBridge.SetRid) {
    console.log("SetRid", rid);
    window.JSBridge.SetRid(rid);
  }
};
